module.exports = __webpack_public_path__ + "static/media/logo-fpt.bed39541.png";